// extracted by mini-css-extract-plugin
export default {"topSection":"Footer_topSection__OsGJb","bottomSection":"Footer_bottomSection__WRzhk"};